<template>
    <div v-if="loading" class="overview-list-item">
        <VueSkeletonLoader
            class="overview-list-item__loading"
            type="rect"
            width="100%"
            height="1.3em"
            animation="wave"
        />
    </div>
    <VehicleField
        v-else
        type="overview"
        :vehicle="vehicle"
        :field="field"
        :tooltip-text="tooltipText"
        :is-link="isLink"
        :field-value="fieldValue"
    />
</template>

<script>
import VehicleField from '~/components/vehicle/VehicleField.vue';

export default {
    components: {
        VehicleField,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        vehicle: {
            type: Object,
            default: null,
        },
        field: {
            type: String,
            default: null,
        },
        tooltipText: {
            type: String,
            default: null,
        },
        isLink: {
            type: Boolean,
            default: false,
        },
        fieldValue: {
            type: String,
            default: '',
        },
    },
};
</script>
